import React, { ReactNode } from "react";
import Link from "../Link";
import Icon from "../Icon";
import Text from "../Text";
export interface IconTextValueProps {
  value: IconTextProps;
}
interface IconTextProps {
  tooltip?: string;
  children: ReactNode;
  className?: string;
  icon?: string;
  iconPosition?: "left" | "right" | "top" | "bottom";
  textClassName?: string;
}
const IconText: React.FC<IconTextValueProps> = ({ value }) => {
  const {
    tooltip,
    children,
    className,
    icon,
    iconPosition = "left",
    textClassName = "px-1"
  } = value;

  const getIconPosition = (iconPosition: string) => {
    switch (iconPosition) {
      case "left":
        return "flex-row";
      case "right":
        return "flex-row-reverse";
      case "top":
        return "flex-col";
      case "bottom":
        return "flex-col-reverse";
    }
  }
  const flexDirection = iconPosition === "top" || iconPosition === "bottom" ? "flex-col" : "flex-row";
  //flex-row-reverse space-x-reverse justify-end
  return (
    
    <div
      title={tooltip}
      className={`flex items-center ${getIconPosition(iconPosition)}  ${className}`}
    >
      <Icon
        value={{
          icon: icon ??  "calender",
          className: "text-secondary",
          iconPosition: "left",
          type: "empty",
        }}
      />
      <Text
        value={{
          injectedChildren: children,
          className: `text-secondary text-sm open-sans-normal ${textClassName}`,
        }}
      />
    </div>
  );
};
export default IconText;
